
import { Vue, Component, Prop } from "vue-property-decorator";
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import { AmCard, AmCardBody } from "@afe/amui/src/components/Card";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmButton } from "@afe/amui/src/components/Button";
import { AmSpacing } from "@afe/amui/src/components/Spacing";
import {
  FormField,
  TextField,
  PhoneField,
  CheckBoxField,
  Preloader,
  FormBack,
  FormError,
  FormSubmit,
  NextSubmit
} from "../components";
import {
  latinValidator,
  DEMO_FORM_STEPS,
  emailValidator,
  mactraderSubmit
} from "@/forms/service";
import { makeAnalytics } from "../analytics";
import Cookie from "js-cookie";
import {
  get_cellxpert_aff_id,
  get_cellxpert_token,
  get_ref_id
} from "@/forms/utils";

@Component({
  validations: {
    email: {
      required,
      maxLength: maxLength(255),
      minLength: minLength(4),
      noMatch: emailValidator
    },
    first_name: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(225),
      noMatch: latinValidator
    },
    last_name: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(225),
      noMatch: latinValidator
    },
    phone_number: {
      maxLength: maxLength(15)
    }
  },
  components: {
    AmCard,
    AmTypography,
    AmCardBody,
    FormField,
    TextField,
    PhoneField,
    CheckBoxField,
    AmSpacing,
    AmButton,
    Preloader,
    FormBack,
    FormError,
    FormSubmit,
    NextSubmit
  }
})
export default class extends Vue {
  @Prop(Object) readonly config!: any;
  @Prop(String) readonly defaultCountry!: string;
  @Prop(Object) readonly formData!: any;

  first_name = "";
  last_name = "";
  email = "";
  phone_number = "";

  mkt_emails = false;

  errors = {};
  loading = false;
  isError = false;
  customError = "";
  analytics = makeAnalytics();

  onSubmit() {
    this.$v.$touch();
    if (this.$v.$invalid) {
      return;
    }

    this.loading = true;
    this.isError = false;

    const {
      cid,
      form_label,
      first_ep,
      predefinedPayload,
      emailType
    } = this.config;
    const { utm } = this.analytics;
    const ref_id = get_ref_id();
    const cellxpert_aff_id = get_cellxpert_aff_id();
    const cellxpert_token = get_cellxpert_token();

    if (first_ep) {
      utm.first.ep = first_ep;
    }

    const formData = {
      email: this.email,
      first_name: this.first_name,
      last_name: this.last_name,
      phone_number: this.phone_number,
      marketing_emails_enabled: this.config.signupCheckbox
        ? this.mkt_emails
        : true,
      trading_panel_request_type: this.config.trading_panel_request_type,
      emailType,
      predefinedPayload,
      ref_id,
      cellxpert_aff_id,
      cellxpert_token,
      utm,
      campaign: { cid, ref_id, form_label },
      raf_referral_code: Cookie.get("raf_code") || "",
      "checkbox-age": true,
      country: this.defaultCountry
    };

    mactraderSubmit(formData)
      .then(({ next, data }) => {
        if (next === DEMO_FORM_STEPS.THANK_YOU_STEP) {
          this.$emit("success", data);
        }
      })
      .catch(({ errors }) => {
        this.loading = false;

        if (errors) {
          this.errors = errors;

          const firstErrorKey = Object.keys(errors).pop();

          if (
            firstErrorKey !== undefined &&
            errors[firstErrorKey] !== undefined
          ) {
            const firstError = errors[firstErrorKey];
            this.customError = this.config.errors[firstError] || "";
          }

          return;
        }

        this.isError = true;
      });
  }
}
